module.exports = __webpack_public_path__ + "img/logo-en-left-white.f4aa910.svg";